import { Directive, Input, SimpleChanges } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn } from '@angular/forms';

export function uniqueValidator(array: any[]): ValidatorFn {
  return (control: AbstractControl): {[key: string]: any} => {
    // test wether all elements in the array are unique
    return array.filter((v,i) => array.indexOf(v)==i).length != array.length ? {'appUniqueArray': {value: control.value}} : null;
  };
}

@Directive({
  selector: '[appUniqueArray]',
  providers: [{provide: NG_VALIDATORS, useExisting: UniqueArrayDirective, multi: true}]

})
export class UniqueArrayDirective {

  @Input('appUniqueArray') array: any[];

  validate(control: AbstractControl): {[key: string]: any} {
    return this.array ? uniqueValidator(this.array)(control)
                              : null;
  }

  registerOnValidatorChange(fn: () => void): void { this._onChange = fn; }
  private _onChange: () => void;

  ngOnChanges(changes: SimpleChanges): void {
 
    if ('array' in changes) {
      
      if (this._onChange) this._onChange();
    }
  }

}
